import React, { useState, useEffect } from 'react';
import './DisclaimerBanner.css';

const DisclaimerBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const seen = typeof window !== 'undefined' ? window.sessionStorage.getItem('urbanix_disclaimer_seen') : null;
    if (seen === '1') return;
    const timer = setTimeout(() => setIsVisible(true), 500);
    return () => clearTimeout(timer);
  }, []);

  const handleAgree = () => {
    if (typeof window !== 'undefined') {
      window.sessionStorage.setItem('urbanix_disclaimer_seen', '1');
    }
    setIsClosing(true);
    setTimeout(() => setIsVisible(false), 300);
  };

  if (!isVisible) return null;

  return (
    <div className={`disclaimer-toast ${isClosing ? 'closing' : ''}`}>
      <div className="disclaimer-toast-content">
        <div className="disclaimer-toast-icon">
          <i className="fi fi-rr-info"></i>
        </div>
        <div className="disclaimer-toast-text">
          <p className="disclaimer-toast-title">הבהרה חשובה</p>
          <p className="disclaimer-toast-message">
            המידע באתר נועד לצרכי מידע כללי בלבד ואינו מהווה תחליף לייעוץ מקצועי. המידע המחייב מצוי במשרדי הרשות המקומית.
          </p>
        </div>
      </div>
      <button 
        className="disclaimer-toast-agree" 
        onClick={handleAgree}
      >
        הבנתי
      </button>
    </div>
  );
};

export default DisclaimerBanner;
